module.exports = __webpack_public_path__ + "assets/img/title-df2786a6.png";